import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { CheckOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import FloatingFormActionsWrapper from "./FloatingFormActions.style";
import { deleteConfirmMessage } from "./formsFeedback";
import RestrictedComponent from "../util/RestrictedComponent";
import ButtonAnimationWrapper from "../animations/ButtonAnimationWrapper";
import { useSelector } from "react-redux";
const FloatingFormActions = (props) => {
  const {
    mode,
    record,
    onDecline,
    onConfirm,
    saveLoading,
    disabled,
    deleteLoading,
    category,
    hideDelete,
    hidePrimary,
    hideDecline,
    resource,
    action,
    onCancel,
    show,
    saveText,
    onSubmit,
    noRestrictions,
  } = props;
  const intl = useIntl();
  const [modal, contextHolder] = Modal.useModal();
  const direction = useSelector(
    (state) => state.user.currentAppLocale.direction
  );
  const onDelete = () => {
    deleteConfirmMessage(
      intl,
      record.name,
      category,
      record.id,
      onConfirm,
      modal
    );
  };

  return (
    <FloatingFormActionsWrapper direction={direction}>
      {noRestrictions ? (
        <Form.Item wrapperCol={{ span: 24 }} style={{ margin: 0 }}>
          <div style={{ display: "flex" }}>
            {hidePrimary ? null : (
              <ButtonAnimationWrapper show={show}>
                <Button
                  className="floatingBtn"
                  loading={saveLoading}
                  disabled={disabled}
                  onClick={onSubmit}
                  htmlType="submit"
                  type="primary"
                  icon={<CheckOutlined />}
                  size={"large"}
                >
                  {" " + saveText}
                </Button>
              </ButtonAnimationWrapper>
            )}
            {hideDecline ? null : (
              <Button
                size="large"
                style={{ minWidth: "100px", margin: "0 10px" }}
                htmlType="button"
                onClick={onDecline}
              >
                <FormattedMessage id="app.actions.decline" />
              </Button>
            )}
            {hideDelete ? null : (
              <Button
                style={{ minWidth: "100px" }}
                size="large"
                danger
                loading={deleteLoading}
                onClick={onDelete}
              >
                {<FormattedMessage id="app.actions.delete" />}
              </Button>
            )}
          </div>
        </Form.Item>
      ) : (
        <RestrictedComponent resource={resource} action={action} comp={null}>
          {contextHolder}
          <Form.Item wrapperCol={{ span: 24 }} style={{ margin: 0 }}>
            <div style={{ display: "flex" }}>
              {hidePrimary ? null : (
                <ButtonAnimationWrapper show={show}>
                  <Button
                    className="floatingBtn"
                    loading={saveLoading}
                    disabled={disabled}
                    onClick={onSubmit}
                    htmlType="submit"
                    type="primary"
                    icon={<CheckOutlined />}
                    size={"large"}
                  >
                    {" " + saveText}
                  </Button>
                </ButtonAnimationWrapper>
              )}
              {hideDecline ? null : (
                <Button
                  size="large"
                  style={{ minWidth: "100px", margin: "0 10px" }}
                  htmlType="button"
                  onClick={onDecline}
                >
                  <FormattedMessage id="app.actions.decline" />
                </Button>
              )}
              {hideDelete ? null : (
                <Button
                  style={{ minWidth: "100px" }}
                  size="large"
                  danger
                  loading={deleteLoading}
                  onClick={onDelete}
                >
                  {<FormattedMessage id="app.actions.delete" />}
                </Button>
              )}
            </div>
          </Form.Item>
        </RestrictedComponent>
      )}
    </FloatingFormActionsWrapper>
  );
};

FloatingFormActions.propTypes = {
  mode: PropTypes.string,
  record: PropTypes.object,
  category: PropTypes.string,
  onDecline: PropTypes.func,
  onConfirm: PropTypes.func,
  saveLoading: PropTypes.bool,
  deleteLoading: PropTypes.bool,
  hideDelete: PropTypes.bool,
  hidePrimary: PropTypes.bool,
  hideDecline: PropTypes.bool,
  disabled: PropTypes.bool,
  resource: PropTypes.string,
  action: PropTypes.string,
  onCancel: PropTypes.func,
};

export default FloatingFormActions;
